import React from 'react';
import PropTypes from 'prop-types';
import Step from '@material-ui/core/Step';
import StepContent from '@material-ui/core/StepContent';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import Tooltip from '@material-ui/core/Tooltip';
import StepperStatusConnector from '../StepperStatusConnector';
import StepperStatusIcon from '../StepperStatusIcon';
import TransportInfo from './TransportInfo';
import styled from 'styled-components';

const StyledStepper = styled(Stepper)`
  && {
    background: none;
    padding: 0;
  }
`;

const TransportsStepper = ({ compact, maxConnectorWidth, orientation, transports, routes }) => {
  const mappedRoutesById = routes.reduce((acc, route) => ({ ...acc, [route.id]: route.label }), {});
  const formattedTransports = transports.reduce((acc, transport) => {
    const fromRoute = mappedRoutesById[transport.from];
    const toRoute = mappedRoutesById[transport.to];

    return [
      ...acc,
      {
        ...transport,
        fromLabel: fromRoute,
        toLabel: toRoute,
      },
    ];
  }, []);
  const activeTransportIndex = formattedTransports.findIndex(
    transport => transport.state !== 'finished',
  );
  const lastTransportIndex = formattedTransports.length > 0 ? formattedTransports?.length : 0;
  const activeStep = activeTransportIndex >= 0 ? activeTransportIndex : lastTransportIndex;

  return (
    <StyledStepper
      activeStep={activeStep}
      orientation={orientation}
      connector={<StepperStatusConnector maxWidth={maxConnectorWidth} />}
    >
      {formattedTransports.map(transport => {
        if (compact) {
          return (
            <Step key={transport?.id}>
              <Tooltip title={`${transport?.fromLabel} - ${transport?.toLabel}`}>
                <StepLabel StepIconComponent={StepperStatusIcon} />
              </Tooltip>
            </Step>
          );
        }

        return (
          <Step key={transport?.id} expanded>
            <StepLabel StepIconComponent={StepperStatusIcon}>
              {transport?.fromLabel} - {transport?.toLabel}
            </StepLabel>
            <StepContent>
              <TransportInfo transport={transport} />
            </StepContent>
          </Step>
        );
      })}
    </StyledStepper>
  );
};

TransportsStepper.propTypes = {
  compact: PropTypes.bool,
  maxConnectorWidth: PropTypes.number,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  transports: PropTypes.array,
  routes: PropTypes.array,
};

TransportsStepper.defaultProps = {
  compact: false,
  maxConnectorWidth: undefined,
  orientation: 'vertical',
  transports: [],
  routes: [],
};

export default TransportsStepper;
